import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAP1zeM21vIH2jNJ0gQBDeOFSr0Gg8Ps_w",
  authDomain: "ta-3-ego-states.firebaseapp.com",
  projectId: "ta-3-ego-states",
  storageBucket: "ta-3-ego-states.firebasestorage.app",
  messagingSenderId: "964905633538",
  appId: "1:964905633538:web:f624c0dc33e9db7d14e41b",
  measurementId: "G-EGYZL11F80"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export default app;

// ── KATMAN A · ANONİM OTURUM (2026-08-09) ────────────────────────────────────
// Firestore kuralları artık `request.auth != null` istiyor: kimliksiz (curl/REST)
// erişim kapalı, admin paneli ve rapor aracı ise okuyabiliyor.
// Oturum uygulama açılışında sessizce alınır — katılımcı hiçbir şey görmez.
// Katılımcı testi tamamlayana dek dakikalar geçtiği için yazma anında oturum hazırdır;
// yine de bekleyebilmek isteyen `authHazir` promise'ini await edebilir.
export const authHazir = signInAnonymously(getAuth(app))
  .catch((err) => { console.error("Anonim oturum açılamadı:", err); });
